module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

const FeatureToggles = Object.freeze({
  IS_CLIENT_CREDENTIALS_LAST_ACCESSED_DATE_ON: 'isClientCredentialsLastAccessedDateOn',
  IS_CONTENT_MANAGEMENT_UI_TEMPLATE_EDIT_DIALOG_SUPPORT_ON: 'isContentManagementUITemplateEditDialogSupportOn',
  IS_CONTENT_MANAGEMENT_UI_TEMPLATE_ENHANCEMENTS_ON: 'isContentManagementUITemplateEnhancementsOn',
  IS_CONTENT_MANAGEMENT_DASHBOARD_ENHANCEMENTS_ON: 'isContentManagementDashboardEnhancementsOn',
  IS_CONTENT_MANAGEMENT_SEARCH_AND_SELECT_SUPPORT_ON: 'isContentManagementSearchAndSelectSupportOn',
  IS_CONTENT_MANAGEMENT_AUTO_ADD_REFERENCE_CODES_ON: 'isContentManagementAutoAddReferenceCodesOn',
  IS_DOWNSTREAM_DATA_LOGGING_ENABLED: 'isDownstreamDataLoggingEnabled',
  IS_EG_IDENTITY_SUPPORT_ENABLED: 'isEGIdentitySupportEnabled',
  IS_EG_IDENTITY_TOOLS_PERMISSION_ENFORCEMENT_ENABLED: 'isEGIdentityToolsPermissionEnforcementEnabled',
  IS_EVENT_DRIVEN_CACHE_INVALIDATION_ENABLED: 'isEventDrivenCacheInvalidationEnabled',
  IS_EVENT_DRIVEN_CACHE_DATA_INTEGRITY_CHECK_ENABLED: 'isEventDrivenCacheDataIntegrityCheckEnabled',
  IS_SERVER_CACHE_BY_DEFAULT_ENABLED: 'isServerCacheByDefaultEnabled',
  IS_OPEN_NEW_TAB_WINDOW_ENABLED: 'isOpenNewTabWindowEnabled',
  IS_VA_MANAGER_CONTENT_CRUD_ON: 'isVAManagerContentCrudOn',
  IS_VA_MANAGER_LIVE_DEBUGGING_ON: 'isVAManagerLiveDebuggingOn',
  IS_CPAAS_TWO_STEP_WIZARD_ENABLED: 'isCpaasTwoStepWizardEnabled',
  IS_CPAAS_SWITCH_PANEL_ENABLED: 'isCpaasSwitchPanelEnabled',
  IS_CPAAS_START_OVER_SKILL_AVAILABLE: 'isCpaasStartOverSkillAvailable',
  IS_UITK_CSTUDIO_DASHBOARD_PAGE_AVAILABLE: 'isUitkCstudioDashboardPageAvailable',
  IS_UITK_CSTUDIO_SKILLGRAPH_PAGE_AVAILABLE: 'isUitkCstudioSkillgraphPageAvailable',
  IS_UITK_CSTUDIO_VADETAILS_PAGE_AVAILABLE: 'isUitkCstudioVaDetailsPageAvailable',
  IS_CROSS_SEGMENT_PARTNER_SETTINGS_SEARCH_ENABLED: 'isCrossSegmentPartnerSettingsSearchEnabled',
  IS_DEBUGGER_LIVE_MODE_ENABLED: 'isDebuggerLiveModeEnabled',
  IS_LLM_ORCHESTRATOR_ENABLED: 'isLLMOrchestratorEnabled',
  IS_DEBUGGER_LIVE_SKILL_GRAPH_WIDGET_SKILL_BUILDER_LINK_ENABLED: 'isDebuggerLiveSkillGraphSkillBuilderLinkEnabled',
  IS_EG_IDENTITY_PARTNER_SELECTION_ENABLED: 'isEGIdentityPartnerSelectionEnabled',
  IS_CONVERSATION_HUB_ENABLED: 'isConversationHubEnabled',
  IS_EGENCIA_DEBUGGER_CONTEXT_ENABLED: 'isEgenciaDebuggerContextEnabled',
  IS_ACTIVE_WIDGET_QUERY_PARAM_ENABLED: 'isActiveWidgetQueryParamEnabled',
  IS_DCF_CAPABILITY_ENABLED: 'isDCFCapabilityEnabled',
  IS_DEBUGGER_MAGIC_SEARCH: 'isDebuggerMagicSearch',
  IS_EG_IDENTITY_TOGGLE_ENABLED_IN_APP_MANAGER: 'isEgIdentityToggleEnabledInAppManager'
});
module.exports = FeatureToggles;

/***/ })
/******/ ]);